var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useId } from 'react';
import { FormField } from './form-field';
import { QuantityInput } from './quantity-input';
export const QuantityInputField = (_a) => {
    var { label, error, description, width, labelClassName = '', tooltip } = _a, props = __rest(_a, ["label", "error", "description", "width", "labelClassName", "tooltip"]);
    const id = useId();
    return (_jsx(FormField, { label: label, error: error, description: description, htmlFor: id, labelVariant: 'label', width: width, labelClassName: labelClassName, tooltip: tooltip, containerClassName: `h-full ${width !== null && width !== void 0 ? width : 'w-full'}`, children: _jsx(QuantityInput, Object.assign({ id: id }, props)) }));
};
